import { useTranslation } from 'react-i18next';

import { useSettingsStore } from '@core/settings/store/settings';

/**
 * Tenant-configurable terminology ("Meeting Rooms", "Units") with i18n-aware
 * defaults: when the tenant has NOT overridden the terminology (store holds
 * the English default), the translated default is returned; tenant-provided
 * values pass through untranslated.
 */
const useTerminology = () => {
  const { t } = useTranslation();
  const { meetingRoomTerminology, unitTerminology } = useSettingsStore();
  return {
    meetingRoomTerminology:
      meetingRoomTerminology === 'Meeting Rooms' ? t('terminology.meetingRooms') : meetingRoomTerminology,
    unitTerminology: unitTerminology === 'Units' ? t('terminology.units') : unitTerminology,
  };
};

export default useTerminology;
